import { PayloadAction } from '@reduxjs/toolkit';
import { Action } from 'redux';

import { TaxonomyWithFacetsView } from '~/types/responseTypes';

export const REQUESTING_FACETS_V2 = 'zola/couples/search/REQUESTING_FACETS_V2';
export const RECEIVED_FACETS_V2 = 'zola/couples/search/RECEIVED_FACETS_V2';

type RequestingFacetsV2Action = Action<typeof REQUESTING_FACETS_V2>;
export type ReceivedFacetsV2Action = PayloadAction<
  TaxonomyWithFacetsView[],
  typeof RECEIVED_FACETS_V2
>;

export type CouplesSearchActions = RequestingFacetsV2Action | ReceivedFacetsV2Action;
